// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2PucL","cardTitle":"Card_cardTitle__38JAT"};